import { loader } from '@tencent/pmd-tools/lib/little-loader';


function getUA() {
  return window.navigator.userAgent.toLowerCase();
}
function isWeiXin() {
  const ua = getUA();
  return ua.indexOf('micromessenger') > -1;
}

function isPc() {
  const { userAgent } = navigator;
  const agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod',
  ];
  let flag = true;
  for (let v = 0; v < agents.length; v++) {
    if (userAgent.indexOf(agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}


function shutdown() {
  const { userAgent } = navigator;
  if (window.mqq?.ui) {
    window.mqq.ui?.popBack();
  }
  if (isWeiXin()) {
    // @ts-ignore
    WeixinJSBridge.call('closeWindow');
  }
  if (userAgent.indexOf('gamehelper') > -1) {
    loader('https://camp.qq.com/h5/webdist/sdk/camp-api/index.umd.min.js')?.then(() => {
      // @ts-ignore
      window?.CampApi?.exit?.();
    })
      .catch((err) => {
        console.error('关闭营地webView失败', err);
        window.close();
      });
    return;
  }

  if (!isPc()) {
    window.opener = null;
    window.open('', '_self', '');
    window.close();
  }

  if (userAgent.indexOf('Firefox') !== -1 || userAgent.indexOf('Chrome') !== -1) {
    window.location.href = 'about:blank';
  } else {
    window.opener = null;
    window.open('about:blank', '_self');
    window.close();
  }
}


export function closeWebview() {
  // #ifdef H5
  shutdown();
  // #endif

  // #ifndef H5
  uni.exitMiniProgram({});
  // #endif
}
